module.exports = __webpack_public_path__ + "media/audios/kid/lesson_3/audio6-2335df91be634c9464c47bbc767ac481.m4a";